import { render } from "./Kontakt.vue?vue&type=template&id=bf8975ba&scoped=true"
import script from "./Kontakt.vue?vue&type=script&lang=js"
export * from "./Kontakt.vue?vue&type=script&lang=js"

import "./Kontakt.vue?vue&type=style&index=0&id=bf8975ba&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf8975ba"]])

export default __exports__